
export class UIGameMapViewLayers {
    readonly bottomLayer: number = 0
    readonly mapTiles: number = 1
    readonly ports: number = 2
    readonly highlightedMapTiles: number = 3
    readonly tileWhiteSurrounding: number = 4
    readonly pirate: number = 5
    readonly mapEdgePieces: number = 6
    readonly mapCityWall: number = 7
    readonly mapCornerPieces: number = 8
    readonly mapCornerKnightPieces: number = 9
    readonly robber: number = 10
    readonly metropolis: number = 11
    readonly chits: number = 12
    readonly topLayer: number = 13
    readonly informationPopups: number = 14
}
